import * as tslib_1 from "tslib";
import * as React from 'react';
var styles = {
    description: {
        fontSize: '13px',
        width: '95%',
        border: 'none',
        padding: '1rem',
        color: 'black',
        whiteSpace: 'pre-line'
    }
};
var TaskDescription = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDescription, _super);
    function TaskDescription(props) {
        return _super.call(this, props) || this;
    }
    TaskDescription.prototype.render = function () {
        return (React.createElement("p", { style: styles.description, dangerouslySetInnerHTML: { __html: this.props.html } }));
    };
    return TaskDescription;
}(React.Component));
export default TaskDescription;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDescription.tsx
// module id = 734
// module chunks = 0